/** 香港上市通道（Overseas patch 261／264） */
export const HK_MARKET_CHANNEL_MENU_IDS = {
  group: 990472,
  desk: 990473,
  view: 990474,
  gate: 990475,
  signup: 990476,
  signupGate: 990477
}

export default HK_MARKET_CHANNEL_MENU_IDS



// WEBPACK FOOTER //
// ./src/constants/hkMarketChannel.js